import React from 'react';
import * as PropTypes from 'prop-types';
import Head from 'next/head';
import { STATIC_PREFIX } from '../../constants/staticPrefix';
import CanonicalURL from '../CanonicalURL/CanonicalURL';

const MetaTags = ({
  metaTitle,
  metaDescription,
  href,
  robotsContent,
  faviconContent,
}) => {
  const title = metaTitle ? `${metaTitle}${metaTitle === 'NFT marketplace BIT.TEAM' ? '' : '. NFT marketplace BIT.TEAM'}`  : 'NFT marketplace BIT.TEAM';
  const description = metaDescription || 'NFT marketplace BIT.TEAM';

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="fb:app_id" content="435211340531642" />
        <meta name="robots" content={robotsContent} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={href} />
        <meta property="og:image" content={faviconContent} />
      </Head>
      <CanonicalURL />
    </>
  );
};

MetaTags.propTypes = {
  metaTitle: PropTypes.string.isRequired,
  metaDescription: PropTypes.string.isRequired,
  href: PropTypes.string,
  robotsContent: PropTypes.string,
  faviconContent: PropTypes.string,
};

MetaTags.defaultProps = {
  href: '/',
  robotsContent: 'index',
  faviconContent: `${process.env.DOMAIN_URL}${STATIC_PREFIX}/favicon.ico`,
};

export default MetaTags;
